import React from "react";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  ContentContainer,
  ModalTitle,
  ModalText,
  ButtonsContainer,
} from "./ApproveConfirmationModal.styled";

interface ApproveConfirmationModalProps {
  onCancel: () => void;
  onApprove: () => void;
  isLoading?: boolean;
}

const ApproveConfirmationModalContent: React.FC<
  ApproveConfirmationModalProps
> = ({ onCancel, onApprove, isLoading }) => {
  const { t } = useTranslation();

  return (
    <ContentContainer>
      <ModalTitle>
        {t("approveConfirmation.title", "Approve Treatment Plan")}
      </ModalTitle>
      <ModalText>
        {t(
          "approveConfirmation.message",
          "Approving this treatment plan will confirm all proposed treatments and make them visible to the care team. You can edit it afterward."
        )}
      </ModalText>
      <ButtonsContainer>
        <Button variant="outlined" onClick={onCancel} disabled={isLoading}>
          {t("common.cancel", "Cancel")}
        </Button>
        <Button variant="contained" onClick={onApprove} disabled={isLoading}>
          {t("approveConfirmation.approveButton", "Approve")}
        </Button>
      </ButtonsContainer>
    </ContentContainer>
  );
};

export default ApproveConfirmationModalContent;


